import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { ProfitLossItem } from '../../pv-calculator.dto';
import { translateProfitLossGroup, translateProfitLossItemName } from '../../utils/profitLossLabels';

export default function PVProfitLossStatement({ profitLossStatement }: { profitLossStatement: ProfitLossItem[] }) {
    const { t } = useTranslation();

    const groupedItems = profitLossStatement.reduce(
        (acc, item) => {
            if (!acc[item.type]) {
                acc[item.type] = [];
            }
            acc[item.type].push(item);
            return acc;
        },
        {} as Record<string, ProfitLossItem[]>,
    );

    return (
        <TableContainer component={Paper} sx={{ overflow: 'auto', height: '30rem' }}>
            <Table stickyHeader size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>{t('Position')}</TableCell>
                        <TableCell>{t('Amount')}</TableCell>
                        <TableCell>{t('Year (0-30)')}</TableCell>
                        <TableCell>{t('Inflation rate')}</TableCell>
                        <TableCell>{t('Lifetime')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Object.entries(groupedItems).map(([groupName, items]) => (
                        <Fragment key={groupName}>
                            <TableRow>
                                <TableCell
                                    colSpan={5}
                                    sx={{ backgroundColor: 'primary.main', color: 'primary.contrastText' }}
                                >
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                        {translateProfitLossGroup(groupName, t)}
                                    </Typography>
                                </TableCell>
                            </TableRow>

                            {items.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{translateProfitLossItemName(item.name, t)}</TableCell>
                                    <TableCell>{item.amount.toFixed(2)} €</TableCell>
                                    {'year_index' in item ? (
                                        <TableCell>{item.year_index}</TableCell>
                                    ) : (
                                        <TableCell></TableCell>
                                    )}
                                    {'inflation_rate' in item ? (
                                        <TableCell>{item.inflation_rate * 100} %</TableCell>
                                    ) : (
                                        <TableCell></TableCell>
                                    )}
                                    {'lifetime' in item ? (
                                        <TableCell>
                                            {item.lifetime} {t('years')}
                                        </TableCell>
                                    ) : (
                                        <TableCell></TableCell>
                                    )}
                                </TableRow>
                            ))}
                        </Fragment>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
